import React, { useEffect, useRef } from "react";
import { Auth } from "aws-amplify";
import { recordLogoutAudit } from "util/logoutAudit";

const IdleTimeoutLogout = () => {
  const logoutStartedRef = useRef(false);

  useEffect(() => {
    if (logoutStartedRef.current) {
      return;
    }

    logoutStartedRef.current = true;

    const signOut = async () => {
      try {
        await recordLogoutAudit("idle_timeout");
        await Auth.signOut({ global: true });
      } catch (error) {
        console.log("error globally signing out after inactivity: ", error);

        try {
          await Auth.signOut();
        } catch (localSignOutError) {
          console.log(
            "error locally signing out after inactivity: ",
            localSignOutError
          );
        }
      } finally {
        window.location.replace("/signin");
      }
    };

    signOut();
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "70vh" }}
    >
      <div className="text-center">
        <h4>Your session has expired</h4>
        <p>Signing you out...</p>
      </div>
    </div>
  );
};

export default IdleTimeoutLogout;
